import { useContext, useState, useEffect } from 'react';
import CustomizerContext from '../../../../_helper/Customizer';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import {useParams, useNavigate } from "react-router-dom";

type RouteParams = {
    tabName?: string;
};

export default function useLinkSettings() {    
    const { layoutURL } = useContext(CustomizerContext);
    const axiosPrivate = useAxiosPrivate();

    const LINK_TYPE = 'link-types';
    const LINK_STATUS = 'link-statuses';
    const INFRASTRUCTURE = 'infrastructures';
    const T_LINK = 'links';
    
    const navigate = useNavigate();
    const { tabName } = useParams<RouteParams>();  
    const [commissionTab, setCommissionTab] = useState<string>(tabName || `${LINK_TYPE}`); 
    
    const tabDisplayNames: { [key: string]: string } = {
        'link-types': 'Link Type',
        'link-statuses': 'Link Status',
        'infrastructures': 'Infrastructure',
        'links': 'Link',
      };

    useEffect(() => {
        if (tabName && tabName !== commissionTab) {
            setCommissionTab(tabName);
        }
    }, [tabName]);

    const handleTabClick = (routeName: string) => {
        setCommissionTab(routeName);
        navigate(`/technical/${routeName}/${layoutURL}`); // Append to route
    };

    return {
        layoutURL,
        LINK_TYPE,
        LINK_STATUS,
        INFRASTRUCTURE,
        T_LINK,
        commissionTab,
        tabDisplayNames,
        handleTabClick
    };
}
